module.exports = __webpack_public_path__ + "img/fendanyun_04.83d23f0c.jpg";